import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { GroupManagementComponent } from '../../features/web/notification/group-management/group-management.component';
import { GroupComponent } from './group/group.component';
import { GroupSkeletonComponent } from './group/skeleton/group-skeleton/group-skeleton.component';
import { PinnedGroupSkeletonComponent } from './group/skeleton/pinned-group-skeleton/pinned-group-skeleton.component';
import { PopularGroupSkeletonComponent } from './group/skeleton/popular-group-skeleton/popular-group-skeleton.component';
import { NotificationComponent } from './notification/notification.component';
import { PeopleSkeletonComponent } from './people/people-skeleton/people-skeleton.component';
import { PeopleComponent } from './people/people.component';
import { PostCommentComponent } from './post-comment/post-comment.component';
import { PostComponent } from './post/post.component';
import { PostSkeletonComponent } from './post/skeleton/post-skeleton/post-skeleton.component';

@NgModule({
    declarations: [
        GroupComponent,
        GroupManagementComponent,
        GroupSkeletonComponent,
        NotificationComponent,
        PeopleComponent,
        PeopleSkeletonComponent,
        PinnedGroupSkeletonComponent,
        PopularGroupSkeletonComponent,
        PostCommentComponent,
        PostComponent,
        PostSkeletonComponent,
    ],
    imports: [
        CommonModule,
        InfiniteScrollDirective,
        MatButtonModule,
        MatMenuModule,
        NgxSkeletonLoaderModule,
        ReactiveFormsModule,
        RouterModule,
    ],
    exports: [
        GroupComponent,
        GroupManagementComponent,
        GroupSkeletonComponent,
        InfiniteScrollDirective,
        NgxSkeletonLoaderModule,
        NotificationComponent,
        PeopleComponent,
        PeopleSkeletonComponent,
        PinnedGroupSkeletonComponent,
        PopularGroupSkeletonComponent,
        PostComponent,
        PostSkeletonComponent,
    ],
})
export class SharedModule {}
